import React from "react";
// import { useParams, useHistory } from "react-router-dom";
import { Flex, Breadcrumbs } from "@jsq/ds/core";
import { FundDetails, FundRowItem } from "@jsq/payments-components";
import { globalEnv } from "~/global-env";

// TODO: uncomment when this is used
// type FundDetailsParams = {
//   id: string;
// };

export const FundDetailsPage: React.FC = () => {
  // TODO: Fetch the actual fund data based on the ID
  // For now, we'll pass null and let the FundDetails component handle it
  // const { id } = useParams<FundDetailsParams>();
  // const history = useHistory();
  const fund: FundRowItem | null = null;

  return (
    <Flex flexDirection="column" gap={16}>
      <Breadcrumbs
        breadcrumbs={[
          {
            path: `${globalEnv.fundAccountingRoute}/cash-processing`,
            name: "Cash Processing",
            icon: "arrow-left",
          },
        ]}
      />
      <FundDetails fund={fund} />
    </Flex>
  );
};
